import {
    Avatar,
    Button,
    Chip,
    Dropdown,
    fetchRoute,
    getCalendarFormat,
    Icon,
    Link,
    PopupModel,
    TDataTableColumnsData,
    Typography
} from "@cakemail-org/ui-components-v2"
import { Stack } from "@mui/material"
import { t } from "i18next"
import { NameTableCol } from "../../components/tables/nameTableCol"
import { ERoutes } from "../../utils/url"
import { TGetListingRowsPopup } from "./types"


export function getListingColsData(): () => TDataTableColumnsData[] {
    return () => [
        {
            id: "name",
            label: t("general-form_other"),
            sortable: true
        },
        {
            id: "published_on",
            label: t("general-status"),
            sortable: true
        },
        {
            id: "branding",
            label: t("general-branding"),
            sortable: true
        },
        {
            id: "list_id",
            label: t("general-list_one"),
            sortable: true
        },
        {
            id: "created_on",
            label: t("general-created_on"),
            sortable: true
        },
        {
            id: "updated_on",
            label: t("general-updated_on"),
            sortable: true
        },
        {
            id: "edited_by",
            label: t("general-edited_by"),
        },
        {
            id: "actions",
            label: ""
        }
    ]
}

export function getListingRows({
    popup,
    partialList,
    users,
    handleOpenPopup,
    handlePreviewPopup,
    handleRenamePopup,
    handleDuplicatePopup,
    handleDeletePopup
}: TGetListingRowsPopup) {
    const actions = <Stack direction="row" gap={3}>
        <Button
            onClick={() => { handleOpenPopup(popup) }}
            size="small"
            color="body1"
            variant="outlined"
        >{t("general-open_one")}</Button>
        <Dropdown
            size="medium"
            color="body1"
            variant="outlined"
            iconOnly
            options={[
                {
                    isAction: true,
                    text: t("general-preview"),
                    postContent: <Icon name="Preview18" />,
                    onClick: () => { handlePreviewPopup(popup) }
                },
                {
                    isAction: true,
                    text: t("general-rename"),
                    postContent: <Icon name="Edit18" />,
                    onClick: () => { handleRenamePopup(popup) }
                },
                {
                    isAction: true,
                    text: t("general-duplicate"),
                    postContent: <Icon name="Document18" />,
                    onClick: () => { handleDuplicatePopup(popup) }
                },
                {
                    isAction: true,
                    text: t("general-delete"),
                    postContent: <Icon name="Delete18" />,
                    onClick: () => { handleDeletePopup(popup) }
                }
            ]}
        />
    </Stack>

    const editedBy = users && users[popup.edited_by.id]
    const isSmartBranding = popup.branding === "smart"
    return {
        name: {
            id: popup.name || "",
            content: <NameTableCol name={popup.name || ""} desc={popup.description || ""} imgSrc={popup.thumbnail_url} />
        },
        edited_by: editedBy ? <Stack direction="row" gap={3} alignItems="center">
            <Avatar variant="square" email={editedBy.email} firstName={editedBy.first_name} lastName={editedBy.last_name} />
            <Typography variant="body1L">{editedBy.first_name} {editedBy.last_name}</Typography>
        </Stack> : "-",
        list_id: <Link href={"#" + fetchRoute({ route: ERoutes.contacts }) + "?listId=" + popup.list_id}>{partialList?.name || popup.list_id}</Link>,
        published_on: <Chip label={popup.published_on && popup.published_on > 0 ? t("general-published") : t("general-unpublished")} color={popup.published_on && popup.published_on > 0 ? "secondary" : "primary"} />,
        branding: <Chip label={t(isSmartBranding ? "general-smart" : "general-basic")} color={isSmartBranding ? "shade150" : "shade150"} />,
        created_on: popup.created_on !== 0 ? getCalendarFormat({ date: popup.created_on, showTime: true }) : "",
        updated_on: popup.updated_on !== 0 ? getCalendarFormat({ date: popup.updated_on, showTime: true }) : "",
        actions
    }
}


export function buildPopupScript({ popup }: { popup?: PopupModel }) {
    if (!popup || (popup.published_on && popup.published_on <= 0)) {
        return "Form not published yet. Please publish the form first."
    }

    return `
<script id="popup-script-${popup.id}">
(function() {
    var script = document.getElementById('popup-script-${popup.id}');
    function insertContent(content) {
        var range = document.createRange();
        var fragment = range.createContextualFragment(content);

        var div = document.createElement('div');
        div.appendChild(fragment);
        div.id = 'popup-content-${popup.id}';
        (script && script.parentNode) ? script.parentNode.insertBefore(div, script) : document.body.appendChild(div);
    }
    
    fetch('${popup.published_url}').then(response => {
            if(response.status === 200) return response.text()
            return response.json()
        }).then(content => {
            if(typeof content === "object") throw content
            insertContent(content);
        }).catch(error => {
            console.error('Error loading form:', error);
        }).finally(()=>{
            if (script) script.remove();
        });
})();
</script>
`
}